<div (click)="toggle()" [ngClass]="isVisible ? 'rotate-180' : 'rotate-0'"
		 class="drop-down-button button ml-4 mr-1"></div>
